module.exports = "<div [formGroup]=\"form\">\n  <ng-template cw-widget-setting></ng-template>\n\n  <div [ngSwitch]=\"setting.type\">\n    <input class=\"form-control\" *ngSwitchCase=\"'string'\" [formControlName]=\"setting.key\" [id]=\"setting.key\" type=\"text\">\n    <clr-checkbox *ngSwitchCase=\"'bool'\" [formControlName]=\"setting.key\"> {{setting.label}}</clr-checkbox>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/widgets/edit-widget-modal/widget-setting/widget-setting.component.html
// module id = ./src/app/widgets/edit-widget-modal/widget-setting/widget-setting.component.html
// module chunks = main